module.exports = __webpack_public_path__ + "static/img/detect07.3331237.png";


//////////////////
// WEBPACK FOOTER
// ./src/module/technology/images/detect07.png
// module id = 581
// module chunks = 4